/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import {REMOVE_TAGS_SUGGESTION_REQUEST, REMOVE_TAGS_SUGGESTION_SUCCESS, REMOVE_TAGS_SUGGESTION_FAILURE} from "../../types";

const AddTagSuggestionsAction = (idTag) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/tags/${idTag}`
        },
        method: 'DELETE',
        headers: (headers()),
        types: [
            REMOVE_TAGS_SUGGESTION_REQUEST,
            {
                type: REMOVE_TAGS_SUGGESTION_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REMOVE_TAGS_SUGGESTION_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REMOVE_TAGS_SUGGESTION_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REMOVE_TAGS_SUGGESTION_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {AddTagSuggestionsAction}